import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveProjectRoles(context, data = {}) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const projectRoles = await axios.get(`/autodesk/bim-360/account-admin/project-roles/${data.projectId}`, config);
        return projectRoles.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
